module.exports = ":host .default-img {\n  width: 210px;\n  height: 210px;\n  display: inline-block;\n  margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.scss
// module id = ./web/modern/components/invoices/invoice-view/invoice-info-table/invoice-info-table.scss
// module chunks = 0